<div class="container-fluid error-404">
    <div class="row align-items-center">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                        <img alt="Error" [src]='environment1 + "assets/images/Error404.svg"' loading="lazy"/>
                        <div class="title-subtitle">
                            <h3>Oops! Page Not Found</h3>
                            <h6>This page doesn’t exist or was removed. We suggest you go back to homepage</h6>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                        <button type="button" class="btn btn-primary btn-md btn-grad-primary btn-brand ps-5 pe-5 pt-2 pb-2" routerLink="/home">Back to Home</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
